/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExchangeFacilitiesByFacilityBatchResponse } from './ExchangeFacilitiesByFacilityBatchResponse';
import {
    ExchangeFacilitiesByFacilityBatchResponseFromJSON,
    ExchangeFacilitiesByFacilityBatchResponseFromJSONTyped,
    ExchangeFacilitiesByFacilityBatchResponseToJSON,
} from './ExchangeFacilitiesByFacilityBatchResponse';

/**
 *
 * @export
 * @interface FindExchangeFacilitiesByFacilityBatch200Response
 */
export interface FindExchangeFacilitiesByFacilityBatch200Response {
    /**
     *
     * @type {ExchangeFacilitiesByFacilityBatchResponse}
     * @memberof FindExchangeFacilitiesByFacilityBatch200Response
     */
    data?: ExchangeFacilitiesByFacilityBatchResponse;
}

/**
 * Check if a given object implements the FindExchangeFacilitiesByFacilityBatch200Response interface.
 */
export function instanceOfFindExchangeFacilitiesByFacilityBatch200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindExchangeFacilitiesByFacilityBatch200ResponseFromJSON(json: any): FindExchangeFacilitiesByFacilityBatch200Response {
    return FindExchangeFacilitiesByFacilityBatch200ResponseFromJSONTyped(json, false);
}

export function FindExchangeFacilitiesByFacilityBatch200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindExchangeFacilitiesByFacilityBatch200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : ExchangeFacilitiesByFacilityBatchResponseFromJSON(json['data']),
    };
}

export function FindExchangeFacilitiesByFacilityBatch200ResponseToJSON(value?: FindExchangeFacilitiesByFacilityBatch200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': ExchangeFacilitiesByFacilityBatchResponseToJSON(value.data),
    };
}
